import Collapsible from './Collapsible';

export default Collapsible;
